import React from 'react'
import tripPriceHelper from './../../../helpers/trip-price.helper'
import TripOptionComponent from './trip-option.component'
import { connect } from 'react-redux'
import { dateHelper } from './../../../helpers/date.helper'

function TripOptionContainer({
	price,
	origin,
	originTerminalName,
	arrival,
	busClass,
	onSelect,
	tripDate,
	className,
	departure,
	promotion,
	freeSeats,
	isLow,
	upgradeTo,
	canUpgrade,
	carrier,
	destination,
	destinationTerminalName,
	showFreeSeats,
	forReturnTrip,
	promotionPercent,
	conversionParameters,
	paymentOptions,
	raceDate,
	legs,
}) {
	const busCompany = carrier ? carrier.tradeName : ''
	// ehConexao nao existe mais no retorno da API - uma oferta e uma conexao
	// quando tem mais de uma perna (legs.length > 1).
	const ehConexao = !!(legs && legs.length > 1)
	const isOnFire = !!isLow
	const daysDiff = dateHelper.getDaysDiff(arrival, departure)
	const showDaysDiff = daysDiff > 0
	const prices = paymentOptions && paymentOptions.length
		? tripPriceHelper.mapPaymentOptions(paymentOptions, promotionPercent)
		: tripPriceHelper.calculatePrices({
			upgradeTo,
			canUpgrade,
			forReturnTrip,
			price: +price.value,
			conversionParameters,
			busCompany,
			promotionPercent,
		})

	return (
		<TripOptionComponent
			origin={origin}
			originTerminalName={originTerminalName}
			tripDate={tripDate}
			busClass={busClass}
			daysDiff={daysDiff}
			isOnFire={isOnFire}
			onSelect={onSelect}
			promotion={promotion}
			className={className}
			freeSeats={freeSeats}
			busCompany={busCompany}
			carrier={carrier}
			rawPrice={+price.value}
			canUpgrade={canUpgrade}
			destination={destination}
			destinationTerminalName={destinationTerminalName}
			prices={prices}
			showDaysDiff={showDaysDiff}
			showFreeSeats={showFreeSeats}
			promotionPercent={promotionPercent}
			arrival={dateHelper.getHours(arrival)}
			departure={dateHelper.getHours(departure)}
			formattedDiff={dateHelper.getFomarttedDiff(departure, arrival)}
			raceDate={raceDate}
			ehConexao={ehConexao}
			legs={legs}
		/>
	)
}

const mapStateToProps = ({ tripPrice }) => ({
	conversionParameters: tripPrice.conversionParameters,
})

const TripOption = connect(mapStateToProps)(TripOptionContainer)

export default TripOption
